module.exports = __webpack_public_path__ + "static/media/task-id.23991151.png";